// ABOUTME: The signed-in user's profile, as the app-wide `me` object exposes it.
// ABOUTME: Settings and parameters are NOT here — screens query them per userID.

import type { UserOldQuery } from "@/graphql/main/gql/graphql"

type UserFullInfo = NonNullable<UserOldQuery["user"]>

export class User {
  constructor(
    public id: string,
    private _info: UserFullInfo,
  ) {}

  get info() {
    return this._info
  }
}
